import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './style.css'
import { useAuthStore } from './stores/auth'
import { initTheme, setSiteBrand, setSkin, setTheme, type SkinId, type ThemeMode } from './theme'

initTheme()

async function loadPublicSite() {
  try {
    const r = await fetch('/api/v1/public/site')
    if (!r.ok) return
    const d = await r.json()
    // 品牌 + 整站主题：管理员在后台设定，对所有用户生效
    if (d.brand_name) setSiteBrand({ name: d.brand_name, sub: d.brand_sub || '' })
    if (d.skin) setSkin(d.skin as SkinId)
    // 明暗：用户本机偏好优先；无偏好时跟服务端默认
    const hasLocalMode = !!localStorage.getItem('theme-mode')
    if (!hasLocalMode && d.theme_mode) setTheme(d.theme_mode as ThemeMode)
  } catch {
    /* offline / first boot */
  }
}

const app = createApp(App)
const pinia = createPinia()

let elementPlusInstall: Promise<void> | null = null
let i18nInstall: Promise<void> | null = null

function needsElementPlus(path: string) {
  return path.startsWith('/ops') || path === '/billing' || path === '/recharge' || path === '/partner/swap'
}

async function ensureElementPlus() {
  if (!elementPlusInstall) {
    elementPlusInstall = import('./plugins/element-plus').then(({ installElementPlus }) => {
      installElementPlus(app)
    })
  }
  await elementPlusInstall
}

async function ensureI18n() {
  if (!i18nInstall) {
    i18nInstall = import('./i18n').then(({ i18n }) => {
      app.use(i18n)
    })
  }
  await i18nInstall
}

// 购买流程只加载成交所需代码；其余页面进入时再安装 UI 与多语言能力。
router.beforeEach(async (to) => {
  await Promise.all([
    needsElementPlus(to.path) ? ensureElementPlus() : Promise.resolve(),
    to.path === '/buy' || to.path === '/buy/result' ? Promise.resolve() : ensureI18n(),
  ])
})

app.use(pinia)
app.use(router)

const authStore = useAuthStore(pinia)
authStore.restore()

// 首屏不等待站点配置接口；页面先显示，品牌与主题随后无刷新更新。
app.mount('#app')
void loadPublicSite()
